<template>
  <transition>
    <div class="clip-con">
      <div class="clip-con-pages">
        <div
          v-for="(data, key) in clipData.clips"
          :key="key"
          class="clip-con-page"
          :data-clip="'clip--' + data.classId"
        >
          <div class="bg"></div>
          <button
            @click="playClip(data.video, data.youtube, data.coming)"
            class="btn"
          >
            play
          </button>
          <button
            v-if="data.story !== undefined"
            @click="playStory(data.story)"
            class="story"
          >
            story
          </button>
        </div>
      </div>
      <div class="clip-con__contents">
        <div
          class="clip-con__tit"
          :class="'clip-con__tit--' + clipData.clipId"
          v-html="clipData.tit"
        ></div>
        <div class="clip-con__desc" v-html="clipData.desc"></div>
      </div>
    </div>
  </transition>
</template>

<script>
import promokit from "@/utils/promokit";
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
  name: "clip-con",
  data() {
    return {
      name: "clip-con",
      slickOptions: {
        arrows: true,
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
      },
    };
  },
  computed: {
    ...mapState(["documentSize", "lang"]),
  },
  props: ["clipData"],
  methods: {
    playStory(txt) {
      const parseRange = document.createRange();
      const parse = Range.prototype.createContextualFragment.bind(parseRange);
      const stories = txt.split("|");

      const layerEle = `<div class="story-layer" id="storyLayer">
            <div class="story-layer__con"></div>
          </div>`;
      document.querySelector("body").appendChild(parse(layerEle));

      const storyCon = document.querySelector(".story-layer__con");
      for (let i = 0; i < stories.length; i++) {
        storyCon.appendChild(
          parse(`
            <div class='story-layer__txt'>${stories[i]}</div>
            `)
        );
      }

      const layer = promokit.layer({
        el: "#storyLayer",
        render: true,
        class: "story",
      });
      layer.open();
      layer.on("closeend", () => {
        document.querySelector(".promokit-layer").remove();
      });
    },
    playClip(video, youtube, coming) {
      const parseRange = document.createRange();
      const parse = Range.prototype.createContextualFragment.bind(parseRange);
      const layerEle = `<div class="video-layer" id="videoLayer">
            <div id="videoPlayer"></div>

          </div>`;
      document.querySelector("body").appendChild(parse(layerEle));

      const player = promokit.video({
        el: "#videoPlayer",
        url: video,
        controls: true,
        mute: false,
      });
      const layer = promokit.layer({
        el: "#videoLayer",
        render: true,
        autoplayVideo: player,
      });
      layer.open();

      if (youtube != "") {
        const youtubeButton = `<button class="clip-con__youtube" data-youtube="${
          youtube[this.lang]
        }"></button>`;
        document
          .querySelector(".promokit-layer")
          .appendChild(parse(youtubeButton));
        document
          .querySelector(".clip-con__youtube")
          .addEventListener("click", (e) => {
            document.querySelector(".promokit-layer").remove();
            this.playYoutube(e);
          });
      }
      if (coming) {
        const comingButton = `<div class="clip-con__coming"></div>`;
        document
          .querySelector(".promokit-layer")
          .appendChild(parse(comingButton));
      }
      layer.on("closeend", () => {
        document.querySelector(".promokit-layer").remove();
      });
    },
    playYoutube(e) {
      const parseRange = document.createRange();
      const parse = Range.prototype.createContextualFragment.bind(parseRange);
      const layerEle = `<div id="videoLayer">
            <div id="videoPlayer"></div>
          </div>`;
      document.querySelector("body").appendChild(parse(layerEle));

      const player = promokit.youtube({
        el: "#videoPlayer",
        youtubeid: e.currentTarget.dataset.youtube,
        controls: true,
        mute: false,
      });
      const layer = promokit.layer({
        el: "#videoLayer",
        render: true,
        autoplayVideo: player,
      });
      layer.open();
      layer.on("closeend", () => {
        document.querySelector(".promokit-layer").remove();
      });
    },
  },
  mounted() {
    $(".clip-con-page").css("minHeight", this.documentSize.h + "px");
    if ($(this.$el).find(".clip-con-page").length > 1)
      $(this.$el).find(".clip-con-pages").slick(this.slickOptions);
    this.$watch("documentSize", (val) => {
      $(".clip-con-page").css("minHeight", val.h + "px");
    });
  },
};
</script>

<style lang="scss">
.clip-con {
  @include position(
    $position: absolute,
    $width: 100%,
    $height: 100%,
    $left: 0,
    $top: 0
  );
  overflow: hidden;
  &-pages {
    position: relative;
  }
  &-page {
    @include position(
      $position: relative,
      $width: 100%,
      $height: 100%,
      $left: 0,
      $top: 0
    );
    min-height: 100vh;
    .bg {
      @include position(
        $position: absolute,
        $width: 100%,
        $height: 100%,
        $left: 0,
        $top: 0
      );
      background-size: auto 100%;
      background-position: 50%;
      &:after {
        @include position(
          $position: absolute,
          $width: 100%,
          $height: 100%,
          $top: 0,
          $left: 0
        );
        @include bg($bg: "../assets/img/bg_cover2.png", $cover: cover);
        content: "";
        opacity: 1;
      }
    }
    .btn {
      @include position($position: absolute, $top: 50%, $left: 50%);
      @include bg($bg: "../assets/img/clip_btn.png", $cover: cover);
      @include hide-text;
      width: 168px;
      height: 168px;
      border-radius: 50%;
    }
    &[data-clip="clip--1"] {
      .bg {
        background-image: url("../assets/img/clip_m_1.jpg");
      }
    }
    &[data-clip="clip--2"] {
      .bg {
        background-image: url("../assets/img/clip_m_2.jpg");
      }
      .btn {
        top: 40%;
      }
    }
    &[data-clip="clip--3-1"] {
      .bg {
        background-image: url("../assets/img/clip_m_3_1.jpg");
      }
      .btn {
        top: 49.5%;
      }
    }
    &[data-clip="clip--3-2"] {
      .bg {
        background-image: url("../assets/img/clip_m_3_2.jpg");
      }
      .btn {
        top: 47%;
      }
    }
    &[data-clip="clip--4"] {
      .bg {
        background-image: url("../assets/img/clip_m_4.jpg");
      }
      .btn {
        top: 54%;
      }
    }
    &[data-clip="clip--5"] {
      .bg {
        background-image: url("../assets/img/clip_m_5.jpg");
      }
      .btn {
        top: 57.5%;
      }
    }
  }
  .story {
    @include position(
      $position: absolute,
      $bottom: 13%,
      $left: 50%,
      $width: 215px * 0.5,
      $height: 173px * 0.5
    );
    @include bg($bg: "../assets/img/icon_story.png", $cover: cover);
    margin-left: -51px;
    @include hide-text;
  }
  &__contents {
    @include position($position: absolute, $top: 0, $left: 50%);
    width: 100%;
  }
  &__tit {
    @include position(
      $position: absolute,
      $width: 400px,
      $height: 45px,
      $top: 50px,
      $left: 50%
    );
    @include hide-text;
    .ko & {
      &--1 {
        @include bg($bg: "../assets/img/ko/clip_1_tit.png", $cover: cover);
      }
      &--2 {
        @include bg($bg: "../assets/img/ko/clip_2_tit.png", $cover: cover);
      }
      &--3 {
        @include bg($bg: "../assets/img/ko/clip_3_tit.png", $cover: cover);
      }
      &--4 {
        height: 125px;
        top: 30px;
        @include bg($bg: "../assets/img/ko/clip_4_tit_m.png", $cover: cover);
        & ~ .clip-con__desc {
          top: 140px;
        }
      }
      &--5 {
        height: 125px;
        top: 30px;
        @include bg($bg: "../assets/img/ko/clip_5_tit_m.png", $cover: cover);
        & ~ .clip-con__desc {
          top: 140px;
        }
      }
    }
    .en & {
      &--1 {
        height: 125px;
        top: 25px;
        @include bg($bg: "../assets/img/en/clip_1_tit_en_m.png", $cover: cover);
        & ~ .clip-con__desc {
          top: 100px;
        }
      }
      &--2 {
        height: 125px;
        top: 25px;
        @include bg($bg: "../assets/img/en/clip_2_tit_en_m.png", $cover: cover);
      }
      &--3 {
        height: 125px;
        top: 25px;
        @include bg($bg: "../assets/img/en/clip_3_tit_en_m.png", $cover: cover);
      }
      &--4 {
        height: 125px;
        top: 25px;
        @include bg($bg: "../assets/img/en/clip_4_tit_en_m.png", $cover: cover);
      }
      &--5 {
        height: 125px;
        top: 25px;
        @include bg($bg: "../assets/img/en/clip_5_tit_en_m.png", $cover: cover);
      }
    }
    .ja & {
      &--1 {
        @include bg($bg: "../assets/img/ja/clip_1_tit_ja.png", $cover: cover);
      }
      &--2 {
        @include bg($bg: "../assets/img/ja/clip_2_tit_ja.png", $cover: cover);
      }
      &--3 {
        @include bg($bg: "../assets/img/ja/clip_3_tit_ja.png", $cover: cover);
      }
      &--4 {
        height: 125px;
        top: 25px;
        @include bg($bg: "../assets/img/ja/clip_4_tit_ja_m.png", $cover: cover);
        & ~ .clip-con__desc {
          top: 140px;
        }
      }
      &--5 {
        height: 125px;
        top: 25px;
        @include bg($bg: "../assets/img/ja/clip_5_tit_ja_m.png", $cover: cover);
        & ~ .clip-con__desc {
          top: 140px;
        }
      }
    }
    .zh & {
      &--1 {
        @include bg($bg: "../assets/img/zh/clip_1_tit_zh.png", $cover: cover);
      }
      &--2 {
        @include bg($bg: "../assets/img/zh/clip_2_tit_zh.png", $cover: cover);
      }
      &--3 {
        @include bg($bg: "../assets/img/zh/clip_3_tit_zh.png", $cover: cover);
      }
      &--4 {
        height: 125px;
        top: 10px;
        @include bg($bg: "../assets/img/zh/clip_4_tit_zh_m.png", $cover: cover);
      }
      &--5 {
        height: 125px;
        top: 25px;
        @include bg($bg: "../assets/img/zh/clip_5_tit_zh_m.png", $cover: cover);
        & ~ .clip-con__desc {
          top: 140px;
        }
      }
    }
  }

  &__desc {
    @include position(
      $position: absolute,
      $width: 100%,
      $top: 100px,
      $left: 50%
    );
    font-size: 13px;
    text-align: center;
    letter-spacing: 0px;
    line-height: 1.8em;
    .en & {
      top: 125px;
    }
  }
  &__youtube {
    //display: none;
    @include hide-text();
    @include position(
      $position: absolute,
      $top: 50%,
      $left: 50%,
      $width: 314px/2,
      $height: 225px/2
    );

    margin-top: calc(100vw / 3.8);
    z-index: 10;
    @include bg($bg: "../assets/img/btn_youtube_ko.png", $cover: cover);
    .en & {
      @include bg($bg: "../assets/img/btn_youtube_en.png", $cover: cover);
    }
    .ja & {
      @include bg($bg: "../assets/img/btn_youtube_ja.png", $cover: cover);
    }
    .zh & {
      @include bg($bg: "../assets/img/btn_youtube_zh.png", $cover: cover);
    }
  }
  &__coming {
    @include hide-text();
    @include position(
      $position: absolute,
      $top: 50%,
      $left: 50%,
      $width: 413px/2,
      $height: 127px/2
    );
    margin-top: calc(100vw / 3);
    z-index: 10;
    @include bg($bg: "../assets/img/btn_coming_ko.png", $cover: cover);
    .en &,
    .ja &,
    .zh & {
      @include bg($bg: "../assets/img/btn_coming_en.png", $cover: cover);
    }
  }
}
.story-layer {
  text-align: center;
  &__txt {
    min-height: 14px;
    font-family: "LineageWIdentity";
    opacity: 0.6;
    //letter-spacing: -3px;
    line-height: 28px;
    font-size: 14px;
    text-shadow: 2px 1px rgba(0, 0, 0, 0.7);
  }
}
.promokit-layer {
  &--story {
    > .promokit-layer__dim {
      opacity: 0.9;
      @include bg($bg: "../assets/img/layer_story_bg.png", $cover: cover);
    }
  }
}
</style>